export default "__VITE_ASSET__zR4iCbBi__"